import React from "react";
import Graph from "./TRIM";
import BehaviourScatterGraph from "../BehaviourScatterGraph";
import { formatNumber } from "@signolteam/shared/units-of-measure";

//metatdata format
let defaultMetadata = {
  trim_m: -0.1, //in meters?
  trim_ideal: 0, // in meters
  et_threshold_max_trim_m: 0.5, // max meters over or under ideal trim to succeed
  et_threshold_min_trim_m: -0.25, // min meters over or under ideal trim to succeed
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);

//metatdata format for range graph
let efficientTrimRangeDefaultMetadata = {
  trim_m: 0.3, //in meters?
  et_threshold_max_trim_m: 0.5, // max meters over or under ideal trim to succeed
  et_threshold_min_trim_m: 0.2, // min meters over or under ideal trim to succeed
};

export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  featureCheck,
  missingDataMsg,
  customerCode,
  isExample,
}) {
  const trim =
    featureCheck("EfficientTrimRangeGraph", customerCode) && isExample
      ? Number(efficientTrimRangeDefaultMetadata["trim_m"])
      : Number(metadata["trim_m"]);
  const perfectTrimM = Number(metadata["trim_ideal"]);
  const lowerLimitMeters =
    featureCheck("EfficientTrimRangeGraph", customerCode) && isExample
      ? Number(efficientTrimRangeDefaultMetadata["et_threshold_min_trim_m"])
      : Number(metadata["et_threshold_min_trim_m"]);
  const upperLimitMeters =
    featureCheck("EfficientTrimRangeGraph", customerCode) && isExample
      ? Number(efficientTrimRangeDefaultMetadata["et_threshold_max_trim_m"])
      : Number(metadata["et_threshold_max_trim_m"]);
  const originLabel = `Even Keel (0 m)`;
  const axisLabel = featureCheck("EfficientTrimRangeGraph", customerCode)
    ? "Actual trim relative to instructed range (m)"
    : "Deviation from even keel (m)";

  if (
    (!featureCheck("EfficientTrimRangeGraph", customerCode) &&
      (isNaN(trim) ||
        isNaN(perfectTrimM) ||
        isNaN(lowerLimitMeters) ||
        isNaN(upperLimitMeters))) ||
    (featureCheck("EfficientTrimRangeGraph", customerCode) &&
      (isNaN(trim) || isNaN(lowerLimitMeters) || isNaN(upperLimitMeters)))
  ) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  if (featureCheck("EfficientTrimRangeGraph", customerCode)) {
    const dotColour =
      trim > upperLimitMeters || trim < lowerLimitMeters
        ? bvrColour.codes["900"]
        : bvrColour.codes["500"];
    const data = [
      {
        x: trim,
        y: 5,
        label: `${trim >= 0 ? "+" : ""}${
          formatNumber(trim, {
            unit: "m",
            precision: 2,
          }).formattedValue
        }`,
        colour: dotColour,
      },
    ];
    const lowestValue =
      trim < lowerLimitMeters ? trim - 0.2 : lowerLimitMeters - 0.2;
    const highestValue =
      trim > upperLimitMeters ? trim + 0.2 : upperLimitMeters + 0.2;
    const domain = [lowestValue, highestValue];
    const refLineColour = bvrColour.codes["900"];
    const refAreaColour = bvrColour.codes["100"];
    const additionalThresholds = [lowerLimitMeters, upperLimitMeters];
    const additionalThresholdsActualValues = [
      isExample
        ? "Threshold"
        : `(${lowerLimitMeters >= 0 ? "+" : ""}${
            formatNumber(lowerLimitMeters, {
              unit: "m",
              precision: 2,
            }).formattedValue
          })`,
      isExample
        ? "Threshold"
        : `(${upperLimitMeters >= 0 ? "+" : ""}${
            formatNumber(upperLimitMeters, {
              unit: "m",
              precision: 2,
            }).formattedValue
          })`,
    ];

    return (
      <BehaviourScatterGraph
        data={data}
        domain={domain}
        additionalThresholdsRelative={additionalThresholds}
        additionalThresholdsActualValues={additionalThresholdsActualValues}
        showRefArea={true}
        dotColour={dotColour}
        refLineColour={refLineColour}
        refAreaColour={refAreaColour}
        hideYAxisOnDesktop={true}
        hideXLineOnMobile={true}
        hideYLineOnMobile={true}
        isExample={isExample}
        axisLabel={axisLabel}
      />
    );
  } else {
    return (
      <Graph
        trim={trim}
        perfectTrimM={perfectTrimM}
        lowerLimitMeters={lowerLimitMeters}
        upperLimitMeters={upperLimitMeters}
        bvrColour={bvrColour}
        originLabel={originLabel}
        axisLabel={axisLabel}
        isExample={isExample}
      />
    );
  }
}
